import React from 'react';
import {Button} from "primereact/button";
import Paper from "@material-ui/core/Paper";
import LinearProgress from "@material-ui/core/LinearProgress";
import Grid from "@material-ui/core/Grid";
import TitlePage from "../../../app/Title/TitlePage/TitlePageView";
import {numberWithComma, price} from "../../../utils/formatters/Numbers";
import NumberFormat from "react-number-format";
import {calculateAmount} from "../../../utils/calculate/Amount";
import {dateDDMMYY} from "../../../utils/formatters/Date";
import {InputText} from "primereact/inputtext";
import SubtitleLabel from "../../../app/Title/SubtitleLabel/SubtitleLabelView";

const OrderPtt = ({
                      ...props
                  }) => {
    return (
        <React.Fragment>
            <LinearProgress color="secondary" id="LinearProgressBar" hidden={!props.isLoading}/>
            <Paper elevation={5}
                   style={{paddingTop: '1%', paddingBottom: '2%', paddingLeft: '2%', paddingRight: '2%'}}>
                {props.messagesGrowl}
                <Grid container spacing={1}>
                    <Grid item xs={8}>
                        <TitlePage title='Ventanilla \ Tomar Postura'/>
                    </Grid>
                    <Grid item xs={4}>
                        <Grid container spacing={2} justify="flex-end">
                            <Grid item>
                                <Button label="Cancelar" onClick={props.handleReturnButton}
                                        className="p-button-secondary"/>
                            </Grid>
                            <Grid item>
                                {props.confMsg}
                            </Grid>
                        </Grid>
                    </Grid>
                    <div className="p-grid">
                        <div className="p-col-4">
                            <SubtitleLabel header="Emisora" isBold={true}/>
                            <SubtitleLabel header={props.orderPtt[0].emisora}/>
                        </div>
                        <div className="p-col-4">
                            <SubtitleLabel header="Precio" isBold={true}/>
                            <SubtitleLabel header= {price(props.orderPtt[0].precio)}/>
                        </div>
                        <div className="p-col-4">
                            <SubtitleLabel header="Cuenta" isBold={true}/>
                            <SubtitleLabel header={props.orderPtt[0].cuenta}/>
                        </div>
                        <div className="p-col-4">
                            <SubtitleLabel header="Títulos" isBold={true}/>
                            <NumberFormat name="cantidad"
                                          value={props.orderPtt[0].cantidad}
                                          thousandSeparator={true}
                                          allowNegative={false}
                                          onChange={props.saveDataOrderBorrower}
                                          placeholder="Ex: 99"
                                          customInput={InputText}/>
                        </div>
                        <div className="p-col-4">
                            <SubtitleLabel header="Importe" isBold={true}/>
                            <SubtitleLabel header={calculateAmount(props.orderPtt[0].precio, props.orderPtt[0].cantidad)}/>
                        </div>
                        <div className="p-col-4">
                            <SubtitleLabel header="Disponible" isBold={true}/>
                            <SubtitleLabel header={numberWithComma(props.orderPtt[0].cantidadDisponible)}/>
                        </div>
                        <div className="p-col-4">
                            <SubtitleLabel header="Plazo" isBold={true}/>
                            <NumberFormat
                                name="plazo"
                                value={props.orderPtt[0].plazo}
                                thousandSeparator={true}
                                onChange={props.saveDataOrderBorrower}
                                maxLength={5}
                                decimalScale={0}
                                allowNegative={false}
                                fixedDecimalScale={false}
                                placeholder="Ex: 99,99"
                                customInput={InputText}/>
                        </div>
                        <div className="p-col-4">
                            <SubtitleLabel header="Fecha Valor" isBold={true}/>
                            <SubtitleLabel header={dateDDMMYY(props.orderPtt[0].fecValor)}/>
                        </div>
                        <div className="p-col-4">&nbsp;</div>
                        <div className="p-col-4">
                            <SubtitleLabel header="Tasa" isBold={true}/>
                            <SubtitleLabel header={props.orderPtt[0].tasa}/>
                        </div>
                        <div className="p-col-4">
                            <SubtitleLabel header="Sobretasa" isBold={true}/>
                            <SubtitleLabel header={props.orderPtt[0].sobreTasa}/>
                        </div>
                    </div>
                </Grid>
            </Paper>
        </React.Fragment>
    )
};

export default (OrderPtt);